import store from '@/store/store'
import { ability } from '@/permissions/rules'

const getAgent = (agentId) => store.dispatch('agent/getAgent', { agentId })

const fetchAgent = async (to, from, next) => {
  const agentId = to.params.agentId
  try {
    await getAgent(agentId)
    next()
  } catch (e) {
    if (ability.can('read', 'AllAgents')) {
      next({ name: 'agencies' })
    } else {
      next({ name: 'agency' })
    }
  }
}

export default fetchAgent
